import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';

import { dateOfBirth } from '../../shared/state/local-cache';

export function residenceMonthResidingValidator(): ValidatorFn {
  return (monthResidingControl: AbstractControl): ValidationErrors | null => {
    const date = monthResidingControl.value;
    const monthYearFormat = 'MM/YYYY';
    const resultFormat = 'months'; // Result format (years, months, days)

    const diff = moment(dateOfBirth(), 'MM/DD/YYYY', true).diff(
      moment(date, monthYearFormat, true),
      resultFormat,
      true
    );
    const diffFromToday = moment().diff(
      moment(date, monthYearFormat, true),
      resultFormat,
      true
    );

    switch (true) {
      case diff > 0:
        return { dobMisMatchError: true };
      case diffFromToday < 0:
        return { futureDateError: true };
      default:
        return null;
    }
  };
}
